import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

export const InvoicesBillsWidgetsSkeleton = ({ isInvoicesWidget }: { isInvoicesWidget?: boolean }) => (
  <div className='box-border w-full h-[322px] rounded-[12px] flex justify-between items-start p-[24px] flex-col'>
    <SkeletonTheme baseColor='#DFE2EB'>
      <div className='w-full flex justify-between'>
        <div>
          <Skeleton width='156px' height='11px' borderRadius='13px' count={1} containerClassName='h-[11px] leading-3' />
        </div>
        <div className='flex'>
          {isInvoicesWidget && (
            <Skeleton
              width='156px'
              height='60px'
              borderRadius='8px'
              count={1}
              containerClassName='mx-[12px] h-[60px] leading-3'
            />
          )}
          <Skeleton width='156px' height='60px' borderRadius='8px' count={1} containerClassName='h-[60px] leading-3' />
        </div>
      </div>
      <div className='flex flex-col mt-[34px] w-full'>
        <Skeleton
          width='100%'
          height='11px'
          borderRadius='13px'
          count={1}
          containerClassName='mb-[36px] h-[11px] leading-3'
        />
        <Skeleton
          width='100%'
          height='11px'
          borderRadius='13px'
          count={1}
          containerClassName='mb-[36px] h-[11px] leading-3'
        />
        <Skeleton
          width='100%'
          height='11px'
          borderRadius='13px'
          count={1}
          containerClassName='mb-[36px] h-[11px] leading-3'
        />
        <Skeleton
          width='220px'
          height='11px'
          borderRadius='13px'
          count={1}
          containerClassName='flex justify-end h-[11px] leading-3'
        />
      </div>
    </SkeletonTheme>
  </div>
);
